/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ImmortalFruitsServerDataParser} from "../ImmortalFruitsServerDataParser";
import {IImmortalFruitsGameData} from "./IImmortalFruitsServerData";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {ImmortalFruitsGameMode} from "../../ImmortalFruitsGameMode";

export class ImmortalFruitsParsedGameData extends SpinParsedGameData{
    public get accumulatedRoundWin(): string {
        return this._accumulatedRoundWin;
    }
    get evaluatedArea(): string[] {
        return this._evaluatedArea;
    }
    private _wheelOneValues: number[];
    private _wheelTwoValues: number[];
    private _wheelThreeValues: number[];
    private _totalWheelTimesBetCollected: number;
    private _totalWheelTimesBetCollectedAfter: number;
    private _totalWheelTimesBetCollectedBefore: number;
    private _wheelLevel: number;
    private _landedWheelIndex: number;
    private _gambleOptionPicked: number;
    private _levelPositionsTakenAfter:boolean[];
    private _gambleColect:boolean;
    private _evaluatedArea : string[];
    private _accumulatedRoundWin : string;

    constructor(rawData:IImmortalFruitsGameData, dataParser:ImmortalFruitsServerDataParser) {
        super(rawData, dataParser);
        //console.log("rawData",rawData)
        this._wheelOneValues = dataParser.parseWheelOneValues(rawData);
        this._wheelTwoValues = dataParser.parseWheelTwoValues(rawData);
        this._wheelThreeValues = dataParser.parseWheelThreeValues(rawData);
        this._totalWheelTimesBetCollected = dataParser.parseTotalWheelTimesBetCollected(rawData);
        this._totalWheelTimesBetCollectedAfter = dataParser.parseTotalWheelTimesBetCollectedAfter(rawData);
        this._totalWheelTimesBetCollectedBefore = dataParser.parseTotalWheelTimesBetCollectedBefore(rawData);
        this._wheelLevel = dataParser.parseWheelLevel(rawData);
        this._landedWheelIndex = dataParser.parseLandedWheelIndex(rawData);
        this._levelPositionsTakenAfter = dataParser.parseLevelPositionsTakenAfter(rawData);
        this._gambleOptionPicked = dataParser.parseGambleOptionPicked(rawData);
        this._gambleColect = dataParser.parseGambleCollection(rawData);
        this._evaluatedArea = dataParser.getEvaluatedArea(rawData);
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
        //this._scatterPositionsEnterFreespin = dataParser.parseScatterPositionsEnterFreespin(rawData);

    }
    public get wheelOneValues(): number[] {
        return this._wheelOneValues;
    }
    public get wheelTwoValues(): number[] {
        return this._wheelTwoValues;
    }
    public get wheelThreeValues(): number[] {
        return this._wheelThreeValues;
    }
    public get levelPositionsTakenAfter(): boolean[] {
        return this._levelPositionsTakenAfter;
    }
    public get totalWheelTimesBetCollected(): number{
        return this._totalWheelTimesBetCollected;
    }
    public get totalWheelTimesBetCollectedAfter(): number{
        return this._totalWheelTimesBetCollectedAfter;
    }
    public get totalWheelTimesBetCollectedBefore(): number{
        return this._totalWheelTimesBetCollectedBefore;
    }
    public get wheelLevel(): number{
        return this._wheelLevel;
    }
    public get LandedWheelIndex(): number{
        return this._landedWheelIndex;
    }
    public get gambleOptionPicked():number{
        return this._gambleOptionPicked;
    }
    protected isFeatureTotalWin(): boolean {
        return (this.mode === ImmortalFruitsGameMode.BONUS_WHEEL && (this.nextMode === ImmortalFruitsGameMode.GAMBLE )|| (this.nextMode === ImmortalFruitsGameMode.NORMAL ) );
    }

}